// extracted by mini-css-extract-plugin
export var assigneeBadge = "_fy-0";
export var assigneeDetails = "_fy-1";
export var assigneeInfo = "_fy-2";
export var dropdownContainer = "_fy-4";
export var dropdownImage = "_fy-5";
export var editAssigneeInfo = "_fy-3";
export var editAssigneeModalContainer = "_fy-6";
export var hidden = "_fy-8";
export var input = "_fy-7";